import qs from 'qs'

import config from '@app/config'
import { communicationsApi } from '@app/services'

import { FetchMessageByIdResponse } from './types'

export const fetchMessageById = async (
  conversationId: number,
  messageId: number | null,
  signal: AbortSignal
) => {
  const lang = config.regionalSettings?.language
  const doNotTranslateFromLanguages =
    config.regionalSettings?.languageExceptions || []

  const { data } = await communicationsApi.get<FetchMessageByIdResponse>(
    `conversation/${conversationId}/messages/${messageId}`,
    {
      params: {
        conversationId,
        messageId,
        lang,
        doNotTranslateFrom: doNotTranslateFromLanguages,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      signal,
    }
  )

  return data
}
